import {selector} from './selector';
import * as events from "./events";

const PageCustomerProfilePrepaidRefundRequest = (function ($) {

    function initEvents() {
        $(document).on('change', selector.ddlBank, events.getBank);
    }

    function initialize() {
        initEvents();
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageCustomerProfilePrepaidRefundRequest};